// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
      config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  };

  let imgArray = [
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-1-1.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-1-2.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-1-3.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-1-4.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-1-5.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-1-6.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-2-1.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-2-2.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-2-3.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-2-4.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-2-5.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-2-6.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-1-1.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-1-2.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-1-3.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-1-4.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-1-5.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-1-6.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-2-1.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-2-2.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-2-3.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-2-4.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-2-5.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-2-6.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-1-1.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-1-2.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-1-3.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-1-4.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-1-5.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-1-6.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-2-1.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-2-2.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-2-3.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-2-4.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-2-5.png',
    'https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-2-6.png',
  ]
  preloadImages(imgArray);

  new Swiper(".sp-swiper1", {
    speed: 9000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
  });

  let prods = window.product
    function getCur(){
      let style = $('#sp-style div.active').attr('data-val')
      let color = $('#sp-color div.active').attr('data-val')
    //   let number = $('#sp-number div.active').attr('data-val')

      return prods.filter(item=> item.option1 == style  )[0]
    }
    function changePrice(){
      let num = $('#calcNumber').val()
      let price = (getCur().price * num / 100).toFixed(2)
      let compare = (getCur().compare_at_price * num / 100).toFixed(2)
    //   price = (price + '').replace('.', ',')
    //   compare = (compare + '').replace('.', ',')
      $('#sp_price1').html(price)
      $('#sp_price2').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
    //   $(".product-part .sp-frees .sp-off").html(off_font);
    }
    $('.sp-btn-style').click(function(){
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })

  $(".sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");

    // 找到当前点击的选项所在的商品区域
    let $currentProduct = $(this).closest('.product-part');

    // 只获取当前商品区域内的选项状态
    let styleOptions = $currentProduct.find("#sp-style .sp-option.active").index();
    let colorOptions = $currentProduct.find("#sp-color .sp-option.active").index();
    let numberOptions = $currentProduct.find("#sp-number .sp-option.active").index();

    const imgArr=[
        "https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-1-1.png",
        "https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-1-1.png",
        "https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-1-1.png",
        "https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-1-2-1.png",
        "https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-2-2-1.png",
        "https://cdn.shopify.com/s/files/1/0899/6726/4034/files/20250929-3-2-1.png"
    ]
    $(".product-part .sp-img-box img").attr("src", imgArr[colorOptions+styleOptions*3]);
    if(numberOptions>0){
        $currentProduct.find('.sp-tips').show()
        if(numberOptions == 1){
            $currentProduct.find('.sp-tips').html('x2')
        }else if(numberOptions == 2){
            $currentProduct.find('.sp-tips').html('x4')
        }else if(numberOptions == 3){
            $currentProduct.find('.sp-tips').html('x10')
        }
    }else{
        $currentProduct.find('.sp-tips').hide()
    }
    changePrice()
  });

  $(".sp-reduce, .sp-add").click(function () {
    // 找到当前按钮所在的商品区域（如 .product-part）
    let $product = $(this).closest('.product-part');
    // 找到数量 input
    let $input = $(this).siblings("input");
    let num = Number($input.val());
    if ($(this).hasClass("sp-reduce")) {
      num = Math.max(1, num - 1);
    } else {
      num = num + 1;
    }
    $input.val(num);
  
    // 更新当前区域的价格
    changePrice()
  });

  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    $(".sp-header-top .sp-cart .num").show();
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-header-top .sp-cart").removeClass("on");
    }, 500);
  });

  $(".product-part .cart-btn").click(function () {
    $(".sp-cart .num").addClass("sp-gray");

    // 找到当前商品区域
    let $product = $(this).closest('.product-part');
    // 找到当前区域的数量 input
    let input = Number($product.find("input[type='number']").val());
    var data = {
          id: getCur().id,
          quantity: $('#calcNumber').val(),
        };
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          success: function () {
            $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
              $("#cardNum").html(result.item_count);
              if (result.item_count > 0) {
                $('.sp-cart .num').css('background', '#cf0101')
              } else {
                $('.sp-cart .num').css('background', '#919191')
              }
            });
          },
          dataType: "json",
        });

    // 当前区域的图片
    var img = $product.find(".sp-img-p");
    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $product.append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        top: finish[0].offsetTop + 115,
        left: finish[0].offsetLeft + finish.width() / 3,
        width: 50,
        height: 50,
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
});

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    $('.selectl span').click(function () {
      $(this).addClass("on").siblings().removeClass("on");
    })

    $(".selectl span").click(function () {
      $(this).addClass("on").siblings().removeClass("on");
    });

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top: offsetTop * $("div#root").css("zoom") - 240 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    var links2 = document.querySelectorAll('a[href^="#add-cart"]');
    links2.forEach(function (link2) {
      link2.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('add-cart');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement2 = document.getElementById("add-cart"); // 获取跳转目标节点
        const offsetTop2 = targetElement2.offsetTop;
        window.scroll({
          top: offsetTop2 * $("div#root").css("zoom")- 240 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }




}

mainRender();

